import * as createAction from './createAction'
import * as errorActions from './errorActions'
import * as authActions from './authActions'
import * as getCareActions from './getCareActions'
import * as apiActions from './apiActions'
import * as navActions from './navActions'
import * as signupActions from './signupActions'
import * as paymentActions from './paymentActions'
import * as analyticsActions from './analyticsActions'
import * as appActions from './appActions'
import * as pushActions from './pushActions'
import * as videoCallActions from './videoCallActions'
import * as medicalInfoActions from './medicalInfoActions'
import * as visitActions from './visitActions'
import * as clinicActions from './clinicActions'
import * as profileActions from './profileActions'
import * as familyMembershipActions from './familyMembershipActions'
import * as followUpBotActions from './followUpBotActions'
import * as providersActions from './providersActions'
import * as localeActions from './localeActions'
import * as nhMemberActions from './nhMemberActions'

export default {
  ...createAction,
  ...errorActions,
  ...authActions,
  ...getCareActions,
  ...apiActions,
  ...navActions,
  ...signupActions,
  ...paymentActions,
  ...analyticsActions,
  ...familyMembershipActions,
  ...appActions,
  ...pushActions,
  ...videoCallActions,
  ...medicalInfoActions,
  ...visitActions,
  ...clinicActions,
  ...profileActions,
  ...followUpBotActions,
  ...providersActions,
  ...localeActions,
  ...nhMemberActions,
}
